<template>
  <li class="todo">
    <div class="formbox" :style="`border: ${hasBorder ? '1px solid #d2d3d6;' : 'none;'}`">
      <div>
        <div class="form-header">
          <div class="left-con-list">
            <scpm-insight-chart-popup
              isNow
              :selected-targets="selectedTargets"
              :selected-metric="modelValue"
              :selected-sub-product="resourceTypeModel2"
              :selected-product-type="resourceTypeModel"
              :should-show-policy-popup="false"
              :insightChartOptions="modelValue"
              :parentClass="parentClass"
              :needCheckPerformance="needCheckPerformance"
              v-if="needCheckPerformance"
            >
              <div class="left-con event-condition-item-title">
                <img src="@/assets/img/scmp/icon_chart_up.png" alt="perf-icon" />
                <strong
                  @mouseover="handleTooltip"
                  v-lego-tooltip="{
                    value: tooltipData,
                    position: 'top',
                    isShowHTML: true
                  }"
                >
                  {{ modelValue.name }}
                </strong>

                <TooltipPerformanceItem
                  v-show="false"
                  ref="tooltipPerformanceItem"
                  :dataTooltip="{ metric: modelValue }"
                />
                <!-- 타입 단위-->
              </div>
            </scpm-insight-chart-popup>
            <div v-else class="left-con disable-click-title">
              <img src="@/assets/img/scmp/icon_chart_up.png" alt="perf-icon" />
              <strong
                @mouseover="handleTooltip"
                v-lego-tooltip="{
                  value: tooltipData,
                  position: 'top',
                  isShowHTML: true
                }"
              >
                {{ modelValue.name }}
              </strong>

              <TooltipPerformanceItem
                v-show="false"
                ref="tooltipPerformanceItem"
                :dataTooltip="{ metric: modelValue }"
              />
              <!-- 타입 단위-->
            </div>
            <em
              >({{ t('page.eventStatus.metricType') }} {{ metricType(modelValue) }},
              {{ t('page.eventStatus.metricUnit') }} {{ metricUnit(modelValue) }})</em
            >
          </div>
          <div class="right-con">
            <lego-icon
              v-if="removeable"
              iconType="df"
              icon="delete"
              sm
              @click="removeItem(modelValue)"
            />
          </div>
        </div>
      </div>
      <div class="form-row" :class="isChangeHistories ? 'gap-15' : ''">
        <div class="form-perf-item" :class="isChangeHistories ? 'gap-item-15' : ''">
          <span class="form-label capitalize">
            <c-label :weight="700" :required="!showReadOnly">{{
              t('page.eventStatus.eventLevelPolicy')
            }}</c-label>
            <!--위험도-->
          </span>
          <div v-if="showReadOnly">
            <div style="display: flex; align-items: center">
              <div style="margin-right: 8px">
                <div style="display: inline-block; max-width: 100%">
                  <div
                    _comment="dangerIcon"
                    style="
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                      width: 20px;
                      height: 20px;
                      text-align: center;
                      border-radius: 50%;
                    "
                    :style="`background-color:${
                      getEventLevelEllipsis(modelValue.eventLevel).iconColor
                    };`"
                  >
                    <em
                      style="
                        height: 20px;
                        color: #fff;
                        font-style: normal;
                        font-size: 11px;
                        cursor: hand;
                        line-height: 20px;
                      "
                    >
                      {{ getEventLevelEllipsis(modelValue.eventLevel).text }}
                    </em>
                  </div>
                </div>
              </div>
              {{ this.$util.capitalize(modelValue.eventLevel) }}
            </div>
          </div>
          <lego-dropdown
            v-if="!showReadOnly"
            :modelValue="modelValue.eventLevel"
            :items="eventLevelItems"
            :disabled="disabled"
            @update:modelValue="changeEventLevel"
            capitalize
          >
            <template v-slot:itemText="itemTextScope">
              <div style="display: flex; align-items: center">
                <div
                  style="margin-right: 8px"
                  class="ellipsis"
                  v-lego-tooltip:ellipsis="itemTextScope.item.value"
                >
                  <div style="display: inline-block; max-width: 100%">
                    <div
                      _comment="dangerIcon"
                      style="
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        width: 20px;
                        height: 20px;
                        text-align: center;
                        border-radius: 50%;
                      "
                      :style="`background-color:${
                        getEventLevelEllipsis(itemTextScope).iconColor
                      }; opacity: ${disabled ? '0.5' : '1'};`"
                    >
                      <em
                        style="
                          height: 20px;
                          color: #fff;
                          font-style: normal;
                          font-size: 11px;
                          cursor: hand;
                          line-height: 20px;
                        "
                      >
                        {{ getEventLevelEllipsis(itemTextScope).text }}
                      </em>
                    </div>
                  </div>
                </div>
                {{ this.$util.capitalize(itemTextScope.item.text) }}
              </div>
            </template>
          </lego-dropdown>
        </div>
        <!-- 이벤트 추가 화면에서 개별항목을 사용하고 있으므로 아래 내용을 지우지 말아주세요... jwooni.park -->
        <div
          class="form-perf-item"
          :class="isChangeHistories ? 'gap-item-15' : ''"
          v-if="useObject && !hiddenIndividualItem"
        >
          <span class="form-label capitalize">
            <c-label :weight="700" :required="isCheckRequired">
              {{ t('page.eventStatus.individualItem') }}
            </c-label>
            <!--개별항목-->
          </span>
          <div v-if="showReadOnly">
            <c-label>
              <c-nodata v-if="this.isASG === 'Y'"></c-nodata>
              <span v-else-if="checkNotShowIndividualItem">-</span>
              <c-nodata v-else :text="`${getTextIndividualItem}`"></c-nodata>
            </c-label>
          </div>
          <lego-dropdown
            v-if="!showReadOnly"
            customValidationStyle="color: red; background-color: white;"
            ref="object"
            :modelValue="modelValue.objectModel"
            :rules="validator.object"
            :items="listIndividual"
            :disabled="disabled || !isCheckRequired"
            @update:modelValue="changeIndividualItem"
          />
          <div v-if="modelValue.isDeletedIndividualItem" class="warning-individual-item">
            <lego-icon iconType="df" icon="del_asg" :size="16" />
            <span class="item-text">{{ $t('page.eventStatus.delIndividualItem') }}</span>
          </div>
        </div>
        <div class="form-perf-item" :class="isChangeHistories ? 'gap-item-15' : ''">
          <span class="form-label">
            <div v-if="showReadOnly">
              <c-label :weight="700">
                {{ t('page.eventStatus.prefix') }}
              </c-label>

              <div style="margin-top: 8px">
                <c-label><c-nodata :text="modelValue.prefix"></c-nodata></c-label>
              </div>
            </div>
            <lego-checkbox
              v-if="!showReadOnly"
              v-model="modelValue.check_prefix"
              :disabled="disabled"
              @update:modelValue="changeCheckPrefix"
            >
              <c-label :weight="700">
                {{ t('page.eventStatus.prefix') }}
              </c-label>
            </lego-checkbox>
            <!--접두사-->
          </span>
          <lego-text-field
            v-if="!showReadOnly"
            ref="prefix"
            showCounter
            :rules="validator.prefix"
            :modelValue="modelValue.prefix"
            :guide="$t('hint.prefixGuide')"
            :disabled="disabled || !modelValue.check_prefix"
            :counter="20"
            :isCounter="false"
            @update:modelValue="changePrefixValue"
          />
        </div>
        <div class="form-perf-item" :class="isChangeHistories ? 'gap-item-15' : ''">
          <span class="form-label">
            <c-label :weight="700" :required="!showReadOnly">{{
              t('page.eventStatus.performanceType')
            }}</c-label>
            <!--성능유형-->
          </span>
          <div v-if="showReadOnly">
            {{
              modelValue.metricFunction === 'NULL'
                ? t('page.eventStatus.collectedValues')
                : t('page.eventStatus.deltaValues')
            }}
          </div>
          <lego-dropdown
            v-if="!showReadOnly"
            :modelValue="modelValue.metricFunction"
            :items="metricFunctionItems"
            :disabled="disabled"
            @update:modelValue="changePerformance"
          />
        </div>
        <div class="form-perf-item" :class="isChangeHistories ? 'gap-item-15' : ''">
          <span class="form-label">
            <c-label :weight="700" :required="!showReadOnly">{{
              t('page.eventStatus.threshold')
            }}</c-label>
            <!--임계치-->
          </span>
          <div v-if="showReadOnly">
            {{ thresholdValue }}
          </div>
          <div v-if="!showReadOnly" class="flex-only" style="gap: 8px">
            <lego-dropdown
              :style="isChangeHistories ? 'width: 60%' : 'width: 50%'"
              ref="thresholdItem"
              :items="thresholdItems"
              :modelValue="modelValue.thresholdItem"
              :disabled="disabled"
              @update:modelValue="onChangeThresholdItem"
            />
            <div class="flex-only threshold-block" style="width: 50%">
              <lego-text-field
                ref="thresholdMin"
                :rules="validator.thresholdMin"
                :modelValue="modelValue.thresholdMin"
                :disabled="disabled"
                :style="`${
                  isChangeHistories ? 'max-width: 200px;' : 'width: 100%;'
                } min-width: auto`"
                :counter="15"
                :isCounter="false"
                maxContentGuide
                :guide="$t('hint.onlyNumericAndDot')"
                @update:modelValue="(value) => onInputThreshold(value, 'min')"
                v-lego-tooltip="{ value: thresholdMinTooltip, position: 'top' }"
              />

              <span v-if="modelValue.thresholdItem == 'range'" style="padding: 5px 10px 0px 10px"
                >~</span
              >
              <lego-text-field
                ref="thresholdMax"
                :rules="validator.thresholdMax"
                v-if="modelValue.thresholdItem == 'range'"
                :modelValue="modelValue.thresholdMax"
                :disabled="disabled"
                :style="`${
                  isChangeHistories ? 'max-width: 200px;' : 'width: 100%;'
                } min-width: auto`"
                :counter="15"
                :isCounter="false"
                maxContentGuide
                :guide="$t('hint.onlyNumericAndDot')"
                @update:modelValue="(value) => onInputThreshold(value, 'max')"
                v-lego-tooltip="{ value: thresholdMaxTooltip, position: 'top' }"
              />
            </div>
          </div>
          <div
            class="threshold-error-message"
            v-if="thresholdMinErrorMessage || thresholdMaxErrorMessage"
          >
            {{ thresholdMinErrorMessage || thresholdMaxErrorMessage }}
          </div>
        </div>
        <div class="form-perf-item" :class="isChangeHistories ? 'gap-item-15' : ''">
          <span class="form-label">
            <div v-if="showReadOnly">
              <c-label :weight="700">
                {{ t('page.eventStatus.statistics') }}
              </c-label>
              <div style="margin-top: 8px">
                <c-label><c-nodata :text="statisticsValue"></c-nodata></c-label>
              </div>
            </div>
            <lego-checkbox
              v-if="!showReadOnly"
              v-model="modelValue.check_statistics"
              :disabled="disabled"
              @update:modelValue="changeCheckStatistics"
            >
              <c-label :weight="700">
                {{ t('page.eventStatus.statistics') }}
              </c-label>
            </lego-checkbox>
            <!--통계-->
          </span>
          <div v-if="!showReadOnly" class="flex-only">
            <lego-dropdown
              ref="statisticsType"
              :items="statisticsTypeItems"
              :modelValue="modelValue.statisticsType"
              @update:modelValue="changeStatisticsType"
              :disabled="disabled || !modelValue.check_statistics"
            />
            <lego-dropdown
              ref="statisticsPeriod"
              :items="statisticsPeriodItems"
              :modelValue="modelValue.statisticsPeriod"
              @update:modelValue="changeStatisticsPeriod"
              :disabled="disabled || !modelValue.check_statistics"
            />
          </div>
        </div>
        <div class="form-perf-item" :class="isChangeHistories ? 'gap-item-15' : ''">
          <div style="margin-bottom: 8px" class="flex-only">
            <c-label style="width: auto; margin-right: 4px" :weight="700" :required="!showReadOnly">
              {{ t('page.eventStatus.eventTolerance') }}
            </c-label>
            <lego-icon class="icon-information icon-information-tooltip" :size="19"
              >information</lego-icon
            >
            <lego-popover top>
              {{ t('page.eventStatus.ftCount') }}
            </lego-popover>
          </div>
          <div v-if="showReadOnly" style="margin-top: 8px">
            {{ modelValue.ftCount }}
          </div>
          <!--지속발생횟수-->
          <lego-text-field
            v-if="!showReadOnly"
            ref="ftCount"
            required
            :modelValue="modelValue.ftCount"
            @update:modelValue="changeEventTolerance"
            :rules="validator.ftCount"
            :counter="2"
            :isCounter="false"
            :disabled="disabled"
            :isFreeText="true"
            :guide="$t('hint.numberRange', { min: minValueFt, max: maxValueFt })"
          />
        </div>
        <div class="form-perf-item" :class="isChangeHistories ? 'gap-item-15' : ''">
          <c-label
            style="margin-bottom: 8px"
            :weight="700"
            :required="!showReadOnly"
            class="capitalize"
          >
            {{ t('page.eventStatus.disableYn') }}
          </c-label>
          <div v-if="showReadOnly" style="margin-top: 8px">
            {{ modelValue.disableYn == 'N' ? t('button.eventActive') : t('button.deactive') }}
          </div>
          <div>
            <ScpmTableSegmentV2
              v-if="!showReadOnly"
              medium
              :disabled="disabled"
              :value="modelValue.disableYn"
              @click="customClick"
            />
          </div>
        </div>

        <div class="form-perf-item" :class="isChangeHistories ? 'gap-item-15' : ''">
          <c-label
            style="margin-bottom: 8px"
            :weight="700"
            :required="!showReadOnly"
            class="capitalize"
          >
            {{ t('page.eventSetting.eventNotificationTimezone') }}
          </c-label>

          <div v-if="!showReadOnly" class="flex-only">
            <lego-dropdown
              class="w-50"
              :modelValue="modelValue.eventOccurTimeZone"
              :rules="validator.eventOccurTimeZone"
              :items="listTimeZone"
              @update:modelValue="changeTimeZone"
            />
            <div
              class="ellipsis w-50"
              v-lego-tooltip="{
                arg: 'ellipsis',
                value: $util.gmtName(modelValue.eventOccurTimeZone),
                class: 'keep-all'
              }"
            >
              {{ $util.gmtName(modelValue.eventOccurTimeZone) }}
            </div>
          </div>

          <c-label v-else class="flex-only event-timezone-text">
            <c-nodata :text="$util.getTextTimeZone(modelValue.eventOccurTimeZone)"></c-nodata>
            <div
              class="ellipsis is-text"
              v-lego-tooltip="{
                arg: 'ellipsis',
                value: $util.gmtName(modelValue.eventOccurTimeZone),
                class: 'keep-all'
              }"
            >
              {{ $util.gmtName(modelValue.eventOccurTimeZone) }}
            </div>
          </c-label>
        </div>
      </div>
    </div>
  </li>
</template>
<script>
import validationMixin from '@/mixins/validation.mixin.js';
import i18nMixin from '@/mixins/i18n.mixin.js';
import TooltipPerformanceItem from '@/containers/components/TooltipPerformanceItem.vue';
import ScpmTableSegmentV2 from '../../../../components/scpm/common/ScpmTableSegmentV2.vue';
import ruleItemValidateMixin from '../mixins/ruleItemValidate.mixin';
import { checkObjectTypesNonSub } from '@/containers/utils/utils.js';
import { getProducts } from '@/containers/components/chart/utils';

export default {
  components: { TooltipPerformanceItem, ScpmTableSegmentV2 },
  mixins: [validationMixin, i18nMixin, ruleItemValidateMixin],
  emits: ['remove', 'change-data', 'update:Validate', 'setObjectName'],
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    hasBorder: {
      type: Boolean,
      default: true
    },
    isChangeHistories: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object
    },
    currentData: {
      type: Object
    },
    detailData: {
      type: Object
    },
    resourceTypeModel: {
      type: String
    },
    resourceTypeModel2: {
      type: String,
      default: null
    },
    productsModel: {
      type: Array,
      default: () => {
        return null;
      }
    },
    metrics: {
      type: Array,
      default: () => {
        return [];
      }
    },
    metricSummary: {
      type: Object,
      default: () => {
        return null;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    removeable: {
      type: Boolean,
      default: true
    },
    objectDisplayName: {
      type: String,
      default: null
    },
    dragChk: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: null
    },
    chkMode: {
      type: String
    },
    hiddenIndividualItem: {
      type: Boolean,
      default: false
    },
    isASG: {
      type: String,
      default: ''
    },
    isHistory: {
      type: Boolean,
      default: false
    },
    parentClass: {
      type: String,
      default: ''
    },
    needCheckPerformance: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    productsModel: {
      deep: true,
      handler(newVal) {
        if (this.$util.isEmpty(newVal)) {
          this.modelValue.check_object = false;
        }
        // 추가시 상품유형이 개별항목일경우 강제로 개별항목 취소 (추가시 개별항목별로 저장됨)
        if (this.modelValue.isObjectExist != 'N') {
          if (newVal.length > 0) {
            this.checkObject(this.modelValue);
          } else {
            this.modelValue.objectModel = '';
            this.modelValue.objectModelDisplay = '';
            this.listIndividual = [];
          }
        }
      }
    },
    modelValue: {
      deep: true,
      handler() {
        // 추가시 상품유형이 개별항목일경우 강제로 개별항목 취소 (추가시 개별항목별로 저장됨)
        if (!this.modelValue.check_prefix) {
          this.modelValue.prefix = '';
        }

        if (this.modelValue.check_statistics) {
          if (this.modelValue.statisticsPeriod <= 5) {
            this.modelValue.statisticsPeriod = 5;
          }
        } else {
          this.modelValue.statisticsType = 'MAX';
          this.modelValue.statisticsPeriod = 5;
        }
        this.validateForSubmit();
      },
      immediate: true
    },
    listIndividual() {
      this.modelValue.isDeletedIndividualItem = this.checkDeletedIndividualItem();
    }
  },
  mounted() {
    this.listTimeZone = this.$util.getListTimeZone();
    this.$nextTick(() => {
      if (
        this.modelValue.isObjectExist == 'Y' &&
        this.productsModel.length > 0 &&
        this.isASG !== 'Y'
      ) {
        this.checkObject(this.modelValue);
      }
    });
  },
  data() {
    return {
      minValueFt: 1,
      maxValueFt: 10,
      tooltipData: '',
      thresholdMinErrorMessage: '',
      thresholdMaxErrorMessage: '',
      eventLevelItems: [
        { value: 'INFORM', text: 'INFORM' },
        { value: 'WARNING', text: 'WARNING' },
        { value: 'FATAL', text: 'FATAL' }
      ],
      metricFunctionItems: [
        { text: this.t('page.eventStatus.collectedValues'), value: 'NULL' },
        { text: this.t('page.eventStatus.deltaValues'), value: 'delta' }
      ],
      thresholdItems: [
        { text: this.t('page.eventStatus.thresholdRa'), value: 'range' },
        { text: this.t('page.eventStatus.thresholdEq'), value: 'EQ' },
        { text: this.t('page.eventStatus.thresholdNe'), value: 'NE' },
        { text: this.t('page.eventStatus.thresholdGe'), value: 'GE' },
        { text: this.t('page.eventStatus.thresholdGt'), value: 'GT' },
        { text: this.t('page.eventStatus.thresholdLe'), value: 'LE' },
        { text: this.t('page.eventStatus.thresholdLt'), value: 'LT' }
      ],
      statisticsTypeItems: [
        { text: this.t('page.eventStatus.statisticsTypeMax'), value: 'MAX' },
        { text: this.t('page.eventStatus.statisticsTypeMin'), value: 'MIN' },
        { text: this.t('page.eventStatus.statisticsTypeAvg'), value: 'AVG' },
        { text: this.t('page.eventStatus.statisticsTypeSum'), value: 'SUM' }
      ],
      statisticsPeriodItems: [
        { text: this.t('page.eventStatus.statisticsPeriod5'), value: 5 },
        { text: this.t('page.eventStatus.statisticsPeriod10'), value: 10 },
        { text: this.t('page.eventStatus.statisticsPeriod30'), value: 30 },
        { text: this.t('page.eventStatus.statisticsPeriod60'), value: 60 },
        { text: this.t('page.eventStatus.statisticsPeriod180'), value: 180 },
        { text: this.t('page.eventStatus.statisticsPeriod360'), value: 360 }
      ],
      validator: {
        ftCount: [this.checkFtCount],
        thresholdMin: [this.checkThresholdMin],
        thresholdMax: [this.checkTthresholdMax],
        object: [this.checkEachItem],
        prefix: [this.checkPrefix],
        eventOccurTimeZone: [this.checkTimeZone]
      },
      listIndividual: [],
      listTimeZone: []
    };
  },
  computed: {
    selectedTargets() {
      let productSummary = this.getProductSummary();
      if(this.detailData.productSummary){
        productSummary = {
          ...productSummary,
          productName: this.detailData.productName,
          name: this.detailData.productName,
          resourceId: this.detailData.productResourceId,
          objectName: productSummary.productSubName || this.detailData.objectName,
          objectType: this.detailData.objectType,
          objectDisplayName: productSummary.productSubName || this.detailData.objectDisplayName
        }
      }
      const targets = productSummary ? [productSummary] : this.productsModel;
      return getProducts(targets, false);
    },
    thresholdMinTooltip() {
      if (this.disabled && this.modelValue.thresholdMin.length > 7)
        return this.modelValue.thresholdMin;
      return '';
    },
    thresholdMaxTooltip() {
      if (this.disabled && this.modelValue.thresholdMax.length > 7)
        return this.modelValue.thresholdMax;
      return '';
    },
    statisticsValue() {
      if (this.modelValue.check_statistics) {
        const type = this.statisticsTypeItems.find(
          (item) => item.value == this.modelValue.statisticsType
        ).text;
        const period = this.statisticsPeriodItems.find(
          (item) => item.value == this.modelValue.statisticsPeriod
        ).text;
        return `${type} / ${period}`;
      }
      return '';
    },
    thresholdValue() {
      const type = this.thresholdItems.find(
        (item) => item.value == this.modelValue.thresholdItem
      ).text;
      return this.modelValue.thresholdItem == 'range'
        ? `${type} / ${this.modelValue.thresholdMin} ~ ${this.modelValue.thresholdMax}`
        : `${type} / ${this.modelValue.thresholdMin}`;
    },
    showReadOnly() {
      return (this.readonly && this.mode === 'view') || this.isChangeHistories;
    },
    useObject: function () {
      return this.productsModel != null;
    },

    metricType: function () {
      return (item) => {
        if (this.$util.isNotEmpty(this.metricSummary)) {
          return this.metricSummary.metricType;
        }
        let result = this.metrics.find((metric) => metric.metricName == item.name);

        if (this.$util.isNotEmpty(result)) {
          return result.metricType;
        }
        return '';
      };
    },

    metricUnit: function () {
      return (item) => {
        if (this.$util.isNotEmpty(this.metricSummary)) {
          return this.metricSummary.metricUnit;
        }
        let result = this.metrics.find((metric) => metric.metricName == item.name);
        if (this.$util.isNotEmpty(result)) {
          return result.metricUnit;
        }
        return '';
      };
    },

    checkDisabledIndividualItem: function () {
      if (!this.modelValue.isObjectExist || this.modelValue.isObjectExist == 'N') return true;

      if (this.modelValue.isObjectExist == 'Y' && this.modelValue.disableObject == 'Y') return true;

      return false;
    },
    checkObjectDisplayName() {
      let check = false;

      this.listIndividual.forEach((e) => {
        if (
          (this.modelValue.objectModel && this.modelValue.objectModel === e.value) ||
          !this.modelValue.objectModel
        )
          check = true;
      });

      return check;
    },
    isCheckRequired() {
      return !!(
        (
          !this.checkDisabledIndividualItem &&
          this.modelValue &&
          this.listIndividual.length &&
          !this.showReadOnly
        )
        // this.checkObjectDisplayName
      );
    },
    checkedIndividualItem: function () {
      if (!this.modelValue.isObjectExist || this.modelValue.isObjectExist == 'N') return false;

      if (this.listIndividual.find((item) => item.value == this.modelValue.objectModel))
        return true;

      return false;
    },

    checkNotShowIndividualItem() {
      const { disableObject, objectModel} = this.modelValue;
      return disableObject === 'Y' && objectModel
    },

    getTextIndividualItem() {
      const { disableObject, objectModel, productSummary, objectDisplayName, metricKey } =
        this.modelValue;
      if (disableObject === 'Y') {
        return '';
      }
      if (this.isExistSubItem && !productSummary?.productSubName && !this.isHistory) {
        return '';
      }
      return (metricKey === 'system.filesystem.used.pct' ? objectDisplayName : objectModel) ?? '';
    },
    isExistSubItem() {
      return checkObjectTypesNonSub(this.resourceTypeModel, this.resourceTypeModel2);
    }
  },
  methods: {
    getProductSummary() {
      return (
        this.modelValue?.productSummary ||
        this.detailData?.productSummary ||
        this.detailData?.groupSummary
      );
    },
    checkDeletedIndividualItem() {
      if (this.chkMode == 'add' || !this.modelValue.objectModel) return false;
      if (this.isExistSubItem && !this.modelValue.productSummary?.productSubName) {
        return false;
      }
      return !this.listIndividual.find((item) => item.value === this.modelValue.objectModel);
    },
    validateForSubmit() {
      let validateArr = [];

      validateArr.push(this.checkFtCountForSubmit());
      validateArr.push(this.checkThresholdMinForSubmit());

      if (this.modelValue.check_prefix) {
        validateArr.push(this.checkPrefixForSubmit());
      }
      if (this.modelValue.thresholdItem === 'range') {
        validateArr.push(this.checkThresholdMaxForSubmit());
      }
      if (this.listIndividual.length) {
        validateArr.push(this.checkEachItemForSubmit());
      }
      this.$emit('update:Validate', {
        key: `${this.modelValue.metricKey}${
          typeof this.modelValue.order !== 'undefined' ? '#' + this.modelValue.order : ''
        }`,
        valid: validateArr.every((invalid) => !!invalid)
      });
    },
    handleTooltip() {
      this.tooltipData = '';
      this.$nextTick(() => {
        if (this.$refs.tooltipPerformanceItem)
          this.tooltipData = this.$refs.tooltipPerformanceItem.$el.innerHTML;
      });
    },
    onChangeThresholdItem(value) {
      if (value !== this.modelValue.thresholdItem) {
        this.modelValue.thresholdItem = value;
        this.setChangeData();
      }
      this.thresholdMaxErrorMessage = '';

      setTimeout(() => {
        this.$util.validate([this.$refs.thresholdMin]);
        this.thresholdMinErrorMessage = '';
      }, 10);
    },
    onInputThreshold(value, type) {
      if (type === 'min') {
        if (value !== this.modelValue.thresholdMin) {
          this.setChangeData();
          this.modelValue.thresholdMin = value;
          this.thresholdMinErrorMessage = '';
        }
      } else {
        if (value !== this.modelValue.thresholdMax) {
          this.setChangeData();
          this.modelValue.thresholdMax = value;
          this.thresholdMaxErrorMessage = '';
        }
      }
    },
    getEventLevelEllipsis(value) {
      let text;
      if (value.item) {
        text = value.item.text.slice(0, 1); //INFORM,WARNING,FATAL=>(I,W,F)
      } else {
        text = value.slice(0, 1);
      }
      let iconColor = '';
      const levelColor = {
        INFORM: '#868d9c',
        WARN: '#ffd035',
        FATAL: '#fb4d58',
        GROUP: '#7199ff'
      };
      switch (text) {
        case 'I':
          iconColor = levelColor.INFORM;
          break;
        case 'W':
          iconColor = levelColor.WARN;
          break;
        case 'F':
          iconColor = levelColor.FATAL;
          break;
        case 'G':
          iconColor = levelColor.GROUP;
          break;
        default:
          iconColor = '#fff';
      }
      return { iconColor, text };
    },
    customClick(disableYn) {
      if (this.modelValue.disableYn !== disableYn.statusValue) {
        this.modelValue.disableYn = disableYn.statusValue;
        this.setChangeData();
      }
    },
    onInputftCount(event) {
      const n = event.target.value.toString().replace(/[^0-9]/g, '');
      this.modelValue.ftCount = Number(n) > 3600 ? 3600 : n;
    },
    checkObject(item) {
      if (!item.isObjectExist || item.isObjectExist == 'N' || this.checkDisabledIndividualItem)
        return;

      if (this.$util.getLstSubResourceType().includes(this.resourceTypeModel)) {
        let apiNm = '';
        let body = {};
        if (['Kubernetes', 'QuickQuery', 'DataWrangler'].includes(this.resourceTypeModel)) {
          body = {
            productIdList: [],
            productObjectType: this.resourceTypeModel2,
            productSubName: this.productsModel.map((e) => e.objectName || e.productSubName)
          };
          this.productsModel.forEach((product) => {
            body.productIdList.push(product.productSq);
          });
          apiNm = '/v1/console/objects/k8s';
        } else if (this.resourceTypeModel === 'Load Balancer') {
          body = { productIds: [] };
          this.productsModel.forEach((product) => {
            body.productIds.push(product.productSq);
          });
          apiNm = '/v1/console/objects/lb';
        } else if (['DataOps', 'DataFlow'].includes(this.resourceTypeModel)) {
          body = { productIds: [] };
          body.productIds = (this.productsModel || []).map((product) => {
            return product.productSq;
          });

          apiNm = '/v1/console/objects/dataops-dataflow';
        }
        let arrNullChk = false;

        if (
          ['Kubernetes', 'QuickQuery', 'DataWrangler'].includes(this.resourceTypeModel) &&
          Array.isArray(body.productIdList) &&
          body.productIdList.length === 0
        ) {
          arrNullChk = true;
        } else if (
          this.$util.getLstSubResourceType().includes(this.resourceTypeModel) &&
          Array.isArray(body.productIds) &&
          body.productIds.length === 0
        ) {
          arrNullChk = true;
        }

        if (arrNullChk == false) {
          this.$http.product
            .post(apiNm, body, true, false, {
              headers: { 'X-ResourceType': this.resourceTypeModel }
            })
            .then((data) => {
              const tmpData = ['Load Balancer', 'DataOps', 'DataFlow'].includes(
                this.resourceTypeModel
              )
                ? data.contents
                : data;

              this.listIndividual = this.$util.replaceArr(tmpData, {
                objectName: 'value',
                objectDisplayName: 'text'
              });

              // if (!this.checkObjectDisplayName) this.modelValue.objectModel = '';
              this.$emit('setObjectName', {
                performanceItemId: this.modelValue.id,
                individualList: this.listIndividual
              });
            });
        }
      } else {
        let key = item.metricKey || item.id;
        let body = { metricKeyList: [key], productIdList: [] };
        this.productsModel.forEach((product) => {
          body.productIdList.push(product.productSq);
        });

        this.$http.product
          .post('/v1/console/objects', body, true, false, {
            headers: { 'X-ResourceType': this.resourceTypeModel }
          })
          .then((data) => {
            this.listIndividual = this.$util.replaceArr(data, {
              objectName: 'value',
              objectDisplayName: 'text'
            });

            // if (!this.checkObjectDisplayName) this.modelValue.objectModel = '';
            this.$emit('setObjectName', {
              performanceItemId: this.modelValue.id,
              individualList: this.listIndividual
            });
          });
      }
    },
    ruleToRuleItem(rule, action = '') {
      let ruleObj = {};
      ruleObj.metricKey = rule.metricKey;
      ruleObj.disableYn = rule.disableYn || 'N';
      ruleObj.disableObject = rule.disableObject;
      ruleObj.name = rule.metricName || rule.metricSummary.metricName;
      ruleObj.objectItems = [];
      ruleObj.objectModel = '';
      ruleObj.objectModelDisplay = '';
      ruleObj.removeKey = rule.removeKey;
      ruleObj.prefix = rule.eventMessagePrefix;
      ruleObj.check_prefix = this.$util.isNotEmpty(rule.eventMessagePrefix);
      ruleObj.ftCount = String(rule.ftCount);
      ruleObj.eventOccurTimeZone =
        rule.eventOccurTimeZone || this.$util.getDefaultTz(this.mode, action);

      if (rule.metricSummary) {
        const {
          metricDescription,
          metricDescriptionEn,
          metricUnit,
          productTargetType,
          productTargetTypeEn
        } = rule.metricSummary;
        ruleObj.metricDescription = metricDescription;
        ruleObj.metricDescriptionEn = metricDescriptionEn;
        ruleObj.metricUnit = metricUnit || '';
        ruleObj.productTargetType = productTargetType;
        ruleObj.productTargetTypeEn = productTargetTypeEn;
      } else {
        const {
          metricDescription,
          metricDescriptionEn,
          metricUnit,
          productTargetType,
          productTargetTypeEn
        } = rule;
        ruleObj.metricDescription = metricDescription;
        ruleObj.metricDescriptionEn = metricDescriptionEn;
        ruleObj.metricUnit = metricUnit || '';
        ruleObj.productTargetType = productTargetType;
        ruleObj.productTargetTypeEn = productTargetTypeEn;
      }

      ruleObj.eventLevel = rule.eventLevel;
      if (this.$util.isNotEmpty(rule.eventThreshold)) {
        ruleObj.metricFunction =
          rule.eventThreshold.metricFunction == '' ? 'NULL' : rule.eventThreshold.metricFunction;

        if (this.$util.isNotEmpty(rule.eventThreshold.rangeThreshold)) {
          ruleObj.thresholdItem = 'range';
          ruleObj.thresholdMin = this.$util.getBigNumber(
            rule.eventThreshold.rangeThreshold.minValue
          );
          ruleObj.thresholdMax = this.$util.getBigNumber(
            rule.eventThreshold.rangeThreshold.maxValue
          );
        } else if (this.$util.isNotEmpty(rule.eventThreshold.singleThreshold)) {
          ruleObj.thresholdItem = rule.eventThreshold.singleThreshold.comparisonOperator;
          ruleObj.thresholdMin = this.$util.getBigNumber(rule.eventThreshold.singleThreshold.value);
          ruleObj.thresholdMax = '';
        }
      }
      if (
        this.$util.isNotEmpty(rule.eventPolicyStatistics) &&
        this.$util.isNotEmpty(rule.eventPolicyStatistics.eventPolicyStatisticsType)
      ) {
        ruleObj.statisticsType = rule.eventPolicyStatistics.eventPolicyStatisticsType;
        ruleObj.statisticsPeriod = rule.eventPolicyStatistics.eventPolicyStatisticsPeriod;
        ruleObj.check_statistics = true;
      } else {
        ruleObj.statisticsType = 'MAX';
        ruleObj.statisticsPeriod = 5;
        ruleObj.check_statistics = false;
      }
      return ruleObj;
    },
    removeItem(removeKey) {
      this.$emit('remove', removeKey);
    },
    validate() {
      let validateArr = [];

      validateArr.push(this.$refs.ftCount);
      validateArr.push(this.$refs.thresholdMin);
      validateArr.push(this.$refs.object);
      if (this.modelValue.check_prefix) {
        validateArr.push(this.$refs.prefix);
      }
      if (this.modelValue.thresholdItem == 'range') {
        validateArr.push(this.$refs.thresholdMax);
      }
      if (!this.$util.validate(validateArr)) {
        return false;
      }
      return true;
    },

    checkFtCount() {
      if (this.disabled) {
        return true;
      }
      const targetValue = this.$refs.ftCount.txtField;

      if (!this.checkEmpty(targetValue)) {
        return this.$t('message.requiredInput');
      }
      if (
        !this.isRealNumber(targetValue) ||
        Number(targetValue) < this.minValueFt ||
        Number(targetValue) > this.maxValueFt
      ) {
        return this.$t('page.template.missingInput');
      }

      return true;
    },
    checkThresholdMin() {
      const minValue = this.$refs.thresholdMin.txtFieldModel;
      const existMax = this.$refs.thresholdMax != undefined;

      if (!this.checkEmpty(minValue)) {
        this.thresholdMinErrorMessage = this.$t('message.requiredInput');
        return this.$t('message.requiredInput');
      }

      if (!this.isRealNumber(minValue)) {
        this.thresholdMinErrorMessage = this.t('message.errorValidateInput');
        return this.t('message.errorValidateInput');
      } else {
        if (!Number.isInteger(minValue * 1) && !this.isDotTwo(minValue)) {
          this.thresholdMinErrorMessage = this.t('message.upTo2Decimal');
          return this.t('message.upTo2Decimal');
        }
      }

      if (existMax) {
        const maxValue = this.$refs.thresholdMax.txtFieldModel;
        if (this.checkEmpty(maxValue) && !this.isThreshold(minValue, maxValue)) {
          if (this.thresholdMaxErrorMessage.length) {
            this.thresholdMinErrorMessage = '';
            return true;
          }
          this.thresholdMinErrorMessage = this.$t('page.widget.riskRangeCheck');
          return this.$t('page.widget.riskRangeCheck');
        }
        if (this.thresholdMaxErrorMessage.length) {
          setTimeout(() => {
            this.$util.validate([this.$refs.thresholdMax]);
          }, 10);
        }
      }
      this.thresholdMinErrorMessage = '';
      return true;
    },
    checkEachItem() {
      if (!this.modelValue.objectModel) {
        return this.$t('page.eventStatus.selectIndividualItems');
      }
      return true;
    },
    checkTthresholdMax() {
      const minValue = this.$refs.thresholdMin.txtFieldModel;
      const maxValue = this.$refs.thresholdMax.txtFieldModel;

      if (!this.checkEmpty(maxValue)) {
        this.thresholdMaxErrorMessage = this.$t('message.requiredInput');
        return this.$t('message.requiredInput');
      }

      if (!this.isRealNumber(maxValue)) {
        this.thresholdMaxErrorMessage = this.t('message.errorValidateInput');
        return this.t('message.errorValidateInput');
      } else {
        if (!Number.isInteger(maxValue * 1) && !this.isDotTwo(maxValue)) {
          this.thresholdMaxErrorMessage = this.t('message.upTo2Decimal');
          return this.t('message.upTo2Decimal');
        }
      }

      if (this.checkEmpty(minValue) && !this.isThreshold(minValue, maxValue)) {
        if (this.thresholdMinErrorMessage.length) {
          setTimeout(() => {
            this.$util.validate([this.$refs.thresholdMin]);
          }, 50);
        }
        this.thresholdMaxErrorMessage = this.$t('page.widget.riskRangeCheck');
        return this.$t('page.widget.riskRangeCheck');
      }
      if (this.thresholdMinErrorMessage.length) {
        setTimeout(() => {
          this.$util.validate([this.$refs.thresholdMin]);
        }, 10);
      }
      this.thresholdMaxErrorMessage = '';
      return true;
    },

    checkThresholdRange() {
      const minValue = this.$refs.thresholdMin.txtFieldModel;
      const maxValue = this.$refs.thresholdMax.txtFieldModel;

      if (
        this.checkEmpty(minValue) &&
        this.checkEmpty(maxValue) &&
        !this.isThreshold(minValue, maxValue)
      ) {
        return this.$t('page.eventStatus.greaterThanTheStartValue');
      }

      return true;
    },
    // 소수점 두자리 체크
    isDotTwo(val) {
      const reg = /\.[0-9]{1,2}$/;
      return reg.test(val);
    },

    checkPrefix() {
      let chkPrefix = this.$refs.prefix.txtField.length;
      if (!this.modelValue.prefix) {
        return this.$t('message.requiredInput');
      }
      if (this.validateTextInput(this.$refs.prefix.txtField)) {
        return this.$t('message.errorValidateInput');
      }
      if (chkPrefix > 20) {
        return this.$t('page.eventStatus.maxPrefix');
      }
      return true;
    },
    checkTimeZone() {
      if (!this.modelValue.eventOccurTimeZone) {
        return this.$t('message.requiredInput');
      }
      return true;
    },
    isPositiveInteger(targetValue) {
      const regNumber = /^[1-9][0-9]|[.]/g;
      return regNumber.test(Number(targetValue));
    },

    isRealNumber(targetValue) {
      const regNumber = /^[0-9]+(\.?[0-9]+)?$/;
      return regNumber.test(targetValue);
    },

    isThreshold(minValue, maxValue) {
      return Number(minValue) < Number(maxValue);
    },
    mutatePrefix(value) {
      return value.replace(this.$const.NOT_ALLOWED_REGEX.EVENT_MESSAGE_PREFIX, '');
    },
    setChangeData() {
      this.$emit('change-data');
    },
    changeEventLevel(value) {
      if (value !== this.modelValue.eventLevel) {
        this.modelValue.eventLevel = value;
        this.setChangeData();
      }
    },
    changeIndividualItem(value, item) {
      if (value !== this.modelValue.objectModel) {
        this.modelValue.objectModel = value;
        this.modelValue.objectModelDisplay = item.text;
        this.setChangeData();
      }
    },
    changeTimeZone(value) {
      if (value !== this.modelValue.eventOccurTimeZone) {
        this.modelValue.eventOccurTimeZone = value;
        this.setChangeData();
      }
    },
    changeCheckPrefix() {
      this.setChangeData();
      this.$refs.prefix.clearValidation();
    },
    changeCheckStatistics() {
      this.setChangeData();
    },
    changePrefixValue(value) {
      if (value !== this.modelValue.prefix) {
        this.modelValue.prefix = value;
        this.$refs.prefix.clearValidation();
        this.setChangeData();
      }
    },
    changePerformance(value) {
      if (value !== this.modelValue.metricFunction) {
        this.modelValue.metricFunction = value;
        this.setChangeData();
      }
    },
    changeStatisticsType(value) {
      if (value !== this.modelValue.statisticsType) {
        this.modelValue.statisticsType = value;
        this.setChangeData();
      }
    },
    changeStatisticsPeriod(value) {
      if (value !== this.modelValue.statisticsPeriod) {
        this.modelValue.statisticsPeriod = value;
        this.setChangeData();
      }
    },
    changeEventTolerance(value) {
      if (value !== this.modelValue.ftCount) {
        this.modelValue.ftCount = value;
        this.setChangeData();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
:deep {
  .lego-dropdown {
    margin-left: 0px !important;
  }
}

.form-label {
  display: inline-block;
  margin-bottom: 8px;
}

.flex-only {
  display: flex;
  gap: 8px;
  align-items: center;
  .w-50 {
    width: 50% !important;
  }
}

.threshold-error-message {
  color: #fc434e;
  font-size: 12px;
  line-height: 16px;
  margin-top: 4px;
}

.active .event-condition-item-title {
  cursor: pointer !important;

  & strong {
    color: #364fc7;

    &:hover {
      text-decoration: underline;
    }
  }
}

.formbox {
  min-height: 160px;
  padding: 16px 24px;
  border-radius: 3px;

  & .form-header {
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding: 0 0 10px;
    border-bottom: 1px solid #d2d3d6;
    & .left-con-list {
      display: flex;
      align-items: center;
      & .left-con {
        flex: 1;
        word-break: break-word;
        padding-right: 5px;
        display: flex;
        align-items: center;
        cursor: default;

        img {
          margin-right: 8px;
        }

        & strong {
          display: inline-block;
          padding: 0 8px 0 0;
          font-size: 14px;
        }
      }
      & em {
        display: inline-block;
        font-style: normal;
        color: #787c84;
        font-size: 14px;
      }
    }
    & .right-con {
      display: flex;
      align-content: center;
      justify-content: flex-end;
      text-align: right;
    }
  }
}

.form-row {
  display: flex;
  margin-left: -30px;
  margin-right: -30px;
  flex-wrap: wrap;

  &.gap-15 {
    margin-left: -15px;
    margin-right: -15px;
  }

  .form-perf-item {
    display: block;
    width: 33.33%;
    padding-top: 16px;
    padding-left: 30px;
    padding-right: 30px;

    &.gap-item-15 {
      padding-left: 15px;
      padding-right: 15px;
    }

    .icon-information {
      margin-left: -8px;
    }
  }
}

:deep .lego-dropdown__message {
  text-align: left;
}

:deep .lego-text-field__message {
  text-align: left;
}

:deep .threshold-block .lego-text-field__message {
  display: none !important;
}

:deep input::placeholder {
  color: #bbbdc1 !important;
}

.warning-individual-item {
  display: flex;
  gap: 4px;
  .item-text {
    font-size: 14px;
    line-height: 20px;
    color: #bd9100;
  }
}
.event-timezone-text {
  &.c-label {
    :deep(.des-class) {
      white-space: nowrap;
      overflow: inherit;
    }
    .is-text {
      width: auto;
    }
  }
}
</style>
